/*
 * SeaMonster Studios custom scripts for Beacon Lighting America.
 * All custom JavaScript lives in this file.
 */

/*
 * Video feature: load the embed only after the visitor presses play.
 * No autoplay on page load (WCAG 2.2.2). Focus moves to the player so keyboard users stay in context.
 */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sms-video-play]');
    if (!button) return;

    var frame = button.closest('[data-sms-video]');
    var src = button.getAttribute('data-src');
    if (!frame || !src) return;

    var iframe = document.createElement('iframe');
    iframe.className = 'sms-video__iframe';
    iframe.src = src;
    iframe.title = button.getAttribute('data-title') || 'Video';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.setAttribute('tabindex', '-1');

    frame.appendChild(iframe);
    button.remove();
    iframe.focus();
  });
})();

/* Contact form: after a send or a failed send the page reloads, so move focus to the status or error summary (WCAG 3.3.1, 4.1.3). */
(function () {
  var message = document.querySelector('[data-sms-form-errors], [data-sms-form-success]');
  if (!message) return;
  message.focus();
  message.scrollIntoView({ block: 'center' });
})();

/* Article share row: the Copy Link button is hidden until scripting and the clipboard are available (WCAG 4.1.3 status message). */
(function () {
  var button = document.querySelector('[data-sms-copy-link]');
  if (!button || !navigator.clipboard) return;
  var status = document.querySelector('[data-sms-copy-status]');
  var timer;

  button.hidden = false;
  button.addEventListener('click', function () {
    navigator.clipboard.writeText(button.getAttribute('data-url') || window.location.href).then(function () {
      if (status) status.textContent = 'Link copied';
      button.textContent = 'Link Copied';
      clearTimeout(timer);
      timer = setTimeout(function () {
        button.textContent = 'Copy Link';
        if (status) status.textContent = '';
      }, 3000);
    });
  });
})();
